import { Link } from "react-router-dom";

import { useUser } from "@/context/user-context";

import { useKeepRelevantParams } from "../../hooks/useKeepRelevantParams";

export const NavigationLink = ({
  to,
  children,
}: {
  to: string;
  children: React.ReactNode;
}) => {
  const keepRelevantParams = useKeepRelevantParams();
  const userContext = useUser();

  return (
    <Link
      className="flex items-center gap-2"
      to={`/workspace/${userContext!.activeWorkspace
        ?.id}/${to}?${keepRelevantParams()}`}
    >
      {children}
    </Link>
  );
};
